'use strict';
/*
* Novicell master
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var novicell = novicell || {};

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  novicell.cookieInfo.init();
  novicell.header.init();
  novicell.languagePicker.init();
  novicell.navigation.init();
  novicell.pageheader.init();
  novicell.sliderSpot.init();
  novicell.statsSpot.init();
  novicell.acordion.init();
  novicell.tableSpot.init();
  novicell.video.init();
  novicell.inputMasking.init();
  novicell.imageSpot.init();
  novicell.filterDropdown.init();
  novicell.scriptSpot.loadingIndicatorIframes();

  // SetTimeout to fix latency with loaded elements in e.g. Vue components
  setTimeout(() => {
    svg4everybody(); // Fix SVG spritemap in IE/Edge
  });

  if (typeof jQuery !== 'undefined') {
    jQuery(window).on('dialog:beforecreate', function () {
      jQuery.scrollLock(true);
    });
    jQuery(window).on('dialog:beforeclose', function () {
      jQuery.scrollLock(false);
    });
  }
});



window.onYouTubeIframeAPIReady = function() {
  novicell.pageheader.loadYouTubeVideos();
  novicell.sliderSpot.loadYouTubeVideos();
};